import { loadable } from '../../common/utils/lazyLoading';

const ErrorPage = loadable(() => import('./ErrorPage'));

export default {
  id: 'error',
  title: 'Error',
  icon: 'profile',
  route: '*',
  component: ErrorPage,
  isPermissionCheckSkipped: true,
};
